import { Store } from 'react-notifications-component';

export const displayNotification = (
  message: string,
  type: 'success' | 'danger' = 'success'
) => {
  Store.addNotification({
    title: message,
    type: type,
    container: 'bottom-center',
    dismiss: { duration: 1000 },
  });
};
